import type { InteractivityPlugin } from './interactivityPluginType';

/**
 * Reports interaction latency distributions for full page editor sessions as the
 * `editor interactivity` operational event.
 *
 * A stub for now: the plugin only registers itself. The collector and the event land in
 * EDITOR-8553.
 */
export const interactivityPlugin: InteractivityPlugin = () => ({
	name: 'interactivity',
});
